import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const TransitionsDashboardPageScheduledAchTransfersPicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.transitionsDashboardPageAdvice.name]: (
      <MetaControlField attr={'scheduledAchTransfers'} />
    ),
  }, null);
};

TransitionsDashboardPageScheduledAchTransfersPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
TransitionsDashboardPageScheduledAchTransfersPicker.defaultProps = {};

export default TransitionsDashboardPageScheduledAchTransfersPicker;
